// Suggested IDs, not an account entitlement catalogue. Custom IDs/deployments remain usable.
// Verified 2026-09-27: https://developers.openai.com/api/docs/models/all
// https://platform.claude.com/docs/en/models/overview
const models: Record<string, string[]> = {
    openai: ['gpt-5.5', 'gpt-5.4', 'gpt-5.4-mini', 'gpt-5.4-nano', 'gpt-4.1', 'gpt-4.1-mini'],
    anthropic: ['claude-sonnet-5', 'claude-opus-5-5', 'claude-haiku-4-5'],
    'azure-openai': [], // Deployment names belong to the customer's Azure resource.
}

export function assistantModelOptions(adapter: string, current: string) {
    return [...new Set([...(models[adapter] ?? []), ...(current ? [current] : [])])]
        .map(value => ({ value, label: value }))
}

export function changeAssistantProvider(previous: Record<string, unknown>, next: Record<string, unknown>) {
    if (previous.adapter === next.adapter) return next
    const endpoints: Record<string, string> = {
        openai: 'https://api.openai.com/v1/responses',
        anthropic: 'https://api.anthropic.com/v1/messages',
        'azure-openai': '',
    }
    // Credentials and model IDs must not accidentally follow a different provider.
    return { ...next, endpoint: endpoints[String(next.adapter)] ?? '', model: '', secret: '' }
}
